import { action } from '@ember/object';
import SettingsCustomersBaseController from '../base';

export default class SettingsCustomersListCreateController extends SettingsCustomersBaseController {
  @action
  cancel() {
    // Delete the record instead of just rolling back
    this.model.destroyRecord();
    this.goToListPage();
  }
}
